'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    ', '\n'], ['\n    ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    min-width: ', ';\n'], ['\n    min-width: ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactIntl = require('react-intl');

var _alignments = require('../../constants/alignments');

var _colors = require('../../constants/colors');

var _sizes = require('../../constants/sizes');

var _grid = require('../../layouts/grid');

var _grid2 = _interopRequireDefault(_grid);

var _row = require('../../layouts/row');

var _row2 = _interopRequireDefault(_row);

var _column = require('../../layouts/column');

var _column2 = _interopRequireDefault(_column);

var _container = require('../../layouts/container');

var _container2 = _interopRequireDefault(_container);

var _header = require('../../atoms/text/header');

var _header2 = _interopRequireDefault(_header);

var _label = require('../../atoms/text/label');

var _label2 = _interopRequireDefault(_label);

var _link = require('../../atoms/link');

var _link2 = _interopRequireDefault(_link);

var _iconButton = require('../../atoms/buttons/iconButton');

var _iconButton2 = _interopRequireDefault(_iconButton);

var _email = require('../../atoms/icons/email');

var _email2 = _interopRequireDefault(_email);

var _call = require('../../atoms/icons/call');

var _call2 = _interopRequireDefault(_call);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var HelpContainer = (0, _styledComponents2.default)(_container2.default)(_templateObject, function (_ref) {
    var isMobile = _ref.isMobile;
    return !isMobile && 'border: 1px solid ' + _colors.Colors.StrokeLight + ';\n        border-radius: 4px;\n    ';
});

var HelpCTA = (0, _styledComponents2.default)(_iconButton2.default)(_templateObject2, function (_ref2) {
    var isMobile = _ref2.isMobile;
    return isMobile ? '100%' : '220px';
});

var HelpSection = function (_React$Component) {
    _inherits(HelpSection, _React$Component);

    function HelpSection(props) {
        _classCallCheck(this, HelpSection);

        var _this = _possibleConstructorReturn(this, (HelpSection.__proto__ || Object.getPrototypeOf(HelpSection)).call(this, props));

        _this.getHelpIcon = function () {
            return _react2.default.createElement(
                'svg',
                { id: 'Help_footer', 'data-name': 'Help footer', xmlns: 'http://www.w3.org/2000/svg', width: '100', height: '100', viewBox: '0 0 100 100' },
                _react2.default.createElement('path', { id: 'Path_12503', 'data-name': 'Path 12503', d: 'M87.02,35.68a37.045,37.045,0,0,0-74.04-.01A14.421,14.421,0,0,0,0,50V62.95a14.408,14.408,0,0,0,14.4,14.4h3.24a4.7,4.7,0,0,0,4.69-4.7V40.29a4.7,4.7,0,0,0-4.69-4.69H15.9a34.136,34.136,0,0,1,68.21,0H82.37a4.7,4.7,0,0,0-4.69,4.69V72.65a4.69,4.69,0,0,0,4.69,4.69h1.78v1.78A11.5,11.5,0,0,1,72.66,90.61h-8.4a7.941,7.941,0,0,0-7.79-6.47H50A7.93,7.93,0,0,0,50,100h6.47a7.941,7.941,0,0,0,7.79-6.47h8.4a14.417,14.417,0,0,0,14.4-14.4V77.28A14.424,14.424,0,0,0,100,62.95V50A14.4,14.4,0,0,0,87.02,35.68Zm-67.6,4.61V72.65a1.784,1.784,0,0,1-1.78,1.78H14.4A11.472,11.472,0,0,1,2.92,62.95V50A11.5,11.5,0,0,1,14.41,38.51h3.23A1.784,1.784,0,0,1,19.42,40.29Zm37.05,56.8H50a5.02,5.02,0,1,1,0-10.04h6.47a5.02,5.02,0,1,1,0,10.04ZM97.09,62.95A11.5,11.5,0,0,1,85.6,74.44H82.36a1.784,1.784,0,0,1-1.78-1.78V40.3a1.784,1.784,0,0,1,1.78-1.78H85.6A11.5,11.5,0,0,1,97.09,50.01Z', fill: _colors.Colors.Primary }),
                _react2.default.createElement(
                    'g',
                    { id: 'Group_2640', 'data-name': 'Group 2640' },
                    _react2.default.createElement('path', { id: 'Path_12504', 'data-name': 'Path 12504', d: 'M50,19.42h0a14.417,14.417,0,0,0-14.4,14.4,1.462,1.462,0,0,0,1.46,1.46h0a1.462,1.462,0,0,0,1.46-1.46A11.5,11.5,0,0,1,50.01,22.34h0a11.488,11.488,0,0,1,3.82,22.32,7.936,7.936,0,0,0-5.29,7.48v1.1a1.46,1.46,0,0,0,2.92,0V52.13A5.026,5.026,0,0,1,54.8,47.4,14.4,14.4,0,0,0,50,19.42Z', fill: _colors.Colors.Secondary }),
                    _react2.default.createElement('path', { id: 'Path_12505', 'data-name': 'Path 12505', d: 'M50,64.73h0a3.075,3.075,0,0,0,0,6.15h0a3.075,3.075,0,0,0,0-6.15Z', fill: _colors.Colors.Secondary })
                )
            );
        };

        _this.state = {
            emailHover: false,
            callHover: false
        };
        return _this;
    }

    _createClass(HelpSection, [{
        key: 'handleCalendlyLink',
        value: function handleCalendlyLink() {
            window.Calendly.showPopupWidget('https://calendly.com/' + this.props.context.configuration.scheduler);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                HelpContainer,
                { fullSize: true,
                    isMobile: this.context.screen.isMobile,
                    left: !this.props.nogutter && _sizes.Sizes.xs,
                    right: !this.props.nogutter && _sizes.Sizes.xs,
                    bottom: _sizes.Sizes.xl
                },
                _react2.default.createElement(
                    _container2.default,
                    { bottom: _sizes.Sizes.xl },
                    _react2.default.createElement(
                        _grid2.default,
                        null,
                        _react2.default.createElement(
                            _row2.default,
                            null,
                            _react2.default.createElement(
                                _column2.default,
                                { xs: 12 },
                                _react2.default.createElement(
                                    _container2.default,
                                    { top: _sizes.Sizes.lg,
                                        horizontalAlignment: _alignments.Alignments.center
                                    },
                                    this.getHelpIcon()
                                ),
                                _react2.default.createElement(_header2.default, {
                                    textAlign: _alignments.Alignments.center,
                                    top: _sizes.Sizes.md,
                                    bottom: _sizes.Sizes.xs,
                                    size: _sizes.Sizes.lg,
                                    text: this.props.mode === 'contact' ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'covera.common.organisms.contact.contactHeader' }) : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'covera.common.organisms.contact.helpHeader' })
                                }),
                                _react2.default.createElement(_label2.default, {
                                    top: _sizes.Sizes.xs,
                                    bottom: _sizes.Sizes.xs,
                                    textAlign: _alignments.Alignments.center,
                                    text: _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: 'covera.common.organisms.contact.helpLabel' })
                                }),
                                _react2.default.createElement(_link2.default, {
                                    top: _sizes.Sizes.sm,
                                    size: _sizes.Sizes.md,
                                    text: this.props.context.configuration.telephoneText || 'Call ' + this.props.context.configuration.telephone,
                                    href: 'tel:' + this.props.context.configuration.telephone
                                })
                            )
                        ),
                        _react2.default.createElement(
                            _row2.default,
                            null,
                            _react2.default.createElement(
                                _column2.default,
                                null,
                                _react2.default.createElement(
                                    _container2.default,
                                    { inline: !this.context.screen.isMobile, fullSize: true, horizontalAlignment: _alignments.Alignments.center },
                                    _react2.default.createElement(
                                        _container2.default,
                                        { fullWidth: this.context.screen.isMobile,
                                            mouseEnterEvent: function mouseEnterEvent() {
                                                return _this2.setState({ emailHover: true });
                                            },
                                            mouseLeaveEvent: function mouseLeaveEvent() {
                                                return _this2.setState({ emailHover: false });
                                            },
                                            bottom: this.context.screen.isMobile && _sizes.Sizes.xs
                                        },
                                        _react2.default.createElement(HelpCTA, {
                                            isMobile: this.context.screen.isMobile,
                                            right: !this.context.screen.isMobile && _sizes.Sizes.sm,
                                            text: _react2.default.createElement(_reactIntl.FormattedMessage, { id: this.props.context.configuration.emailText || 'covera.common.organisms.contact.helpEmail' }),
                                            icon: _react2.default.createElement(_email2.default, { primary: this.state.emailHover ? _colors.Colors.Secondary : _colors.Colors.Primary }),
                                            clickEvent: function clickEvent() {
                                                return document.location.href = 'mailto:' + _this2.props.context.configuration.email + '?subject=Contact';
                                            }
                                        })
                                    ),
                                    _react2.default.createElement(
                                        _container2.default,
                                        { fullWidth: this.context.screen.isMobile,
                                            mouseEnterEvent: function mouseEnterEvent() {
                                                return _this2.setState({ callHover: true });
                                            },
                                            mouseLeaveEvent: function mouseLeaveEvent() {
                                                return _this2.setState({ callHover: false });
                                            }
                                        },
                                        _react2.default.createElement(HelpCTA, {
                                            isMobile: this.context.screen.isMobile,
                                            text: _react2.default.createElement(_reactIntl.FormattedMessage, { id: this.props.context.configuration.schedulerText || 'covera.common.organisms.contact.helpSchedule' }),
                                            clickEvent: function clickEvent() {
                                                return _this2.handleCalendlyLink();
                                            },
                                            icon: _react2.default.createElement(_call2.default, { primary: this.state.callHover ? _colors.Colors.Secondary : _colors.Colors.Primary })
                                        })
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return HelpSection;
}(_react2.default.Component);

HelpSection.contextTypes = {
    screen: _propTypes2.default.object
};

exports.default = HelpSection;